import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { BlockRenderer } from "../../components/block_renderer";
import { Jumbo, renderContents } from "../../components/jumbo";
import { ReactionsLayout } from "../../components/reactions/reactionsLayout";
export const BlogPostLayout = (props)=>{
    const { id, headerTitle, description, phImageUrl, phImageUrlFallback, phImageUrlLarge, imageAlt, blocks, categories, dateCreated, reactionProps } = props;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                title: headerTitle,
                contents: dateCreated.format("dddd D MMMM YYYY"),
                imageUrl: phImageUrl,
                imageUrlFallback: phImageUrlFallback,
                imageUrlLarge: phImageUrlLarge,
                imageAlt: imageAlt,
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "intro",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "intro__inner container--sg align--center",
                    children: [
                        categories && categories.size > 0 && /*#__PURE__*/ _jsx("div", {
                            className: "intro__tags tags",
                            children: /*#__PURE__*/ _jsx("ul", {
                                className: "tags__list",
                                children: categories.map((c)=>/*#__PURE__*/ _jsx("li", {
                                        className: "tags__item",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "tags__tag",
                                            children: c.label
                                        })
                                    }, `category-${c.url}`))
                            })
                        }),
                        description.toString().length > 0 && /*#__PURE__*/ _jsx("div", {
                            className: "intro__text text--l text--styled",
                            children: renderContents(description, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BlockRenderer, {
                blocks: blocks
            }),
            /*#__PURE__*/ _jsx(ReactionsLayout, {
                ...reactionProps
            })
        ]
    }, `blogpost-${id}`);
};
